import React from 'react'
import { Link } from 'react-router-dom'

const GameImage = (props) => {
  const gamelink = '/gameinfo/' + props.game.gameId;

  if (props.game.logo != null) {
    let imgurl = '/' + props.game.logo;
    if (props.game.logo.startsWith("http")) {
      imgurl = props.game.logo;
    }
    return (
      <Link to={gamelink}>
        <img className="gameimage" src={imgurl} alt={props.game.name}/>
      </Link>
    );
  } else {
    return (
      <Link to={gamelink}>
        <div>{props.game.name}</div>
      </Link>
    );
  }
};

export default GameImage;



// WEBPACK FOOTER //
// ./src/components/GameImage.js